import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSucursales } from '../services/api/authService';
import { AppAgendaContext } from '../context/AppAgendaContext';
import PageContainer from '../components/pageContainer';
import WizardPaso2 from '../components/WizardPaso2';
import { Content, Title, Subtitle, Form } from '../styles/pacienteStyles';
import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaMapMarkerAlt } from "react-icons/fa";

const SeleccionaTipoHora = () => {
  const {
    setContextData,
    setPasoActual,
    setUltimoEventoGTM,
    sessionId,
    utmData,
    registrarEventoVisual
  } = useContext(AppAgendaContext);
  const [nombrePaciente, setNombrePaciente] = useState('');
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [direccion, setDireccion] = useState('Seleccione una sucursal para ver la dirección');
  const logEvento = async ({ paso, evento, descripcion, campo, valor }) => {
    const payload = {
      session_id: sessionId,
      paso,
      evento,
      descripcion,
      campo_afectado: campo || null,
      valor_ingresado: valor || null,
      fecha_evento: new Date().toISOString(),
      ...utmData,
      origen_referrer: document.referrer || null
    };

    try {
      await fetch('/api/agendamiento/evento', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch (error) {
      console.error("Error enviando evento:", error);
    }
  };  
  const navigate = useNavigate();
  
  useEffect(() => {
    setPasoActual("SeleccionaTipoHoraSucursal");
   
    registrarEventoVisual({
      paso: 'SeleccionaTipoHora',
      evento: 'carga_pagina',
      descripcion: 'Entró a SeleccionaTipoHora'
    });

    logEvento({
      paso: 'SeleccionaTipoHora',
      evento: 'carga_pagina',
      descripcion: 'Usuario accede al paso SeleccionaTipoHora'
    });
  
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "paso_tipo_hora" });
  
    setUltimoEventoGTM("paso_tipo_hora_sucursal");
  }, []);

  useEffect(() => {
    const pacienteInfo = JSON.parse(sessionStorage.getItem('pacienteInfo'));
    if (pacienteInfo && pacienteInfo.pacNombre) {
      const primerNombre = pacienteInfo.pacNombre.split(' ')[0];
      setNombrePaciente(primerNombre);
    }

    const fetchSucursales = async () => {
      try {
        const sucursalesData = await getSucursales();

        const sucursalesPermitidas = JSON.parse(sessionStorage.getItem("flujoActivo"))?.sucursalesPermitidas;

        if (Array.isArray(sucursalesPermitidas) && sucursalesPermitidas.length > 0) {
          const filtradas = sucursalesData.filter(suc => sucursalesPermitidas.includes(suc.sucId));
          setSucursales(filtradas);
        } else {
          setSucursales(sucursalesData); // fallback por si no hay restricciones
        }

      } catch (error) {
        console.error('Error al obtener sucursales:', error);
      }
    };

    fetchSucursales();
  }, []);

  const handleSucursalChange = (sucursal) => {
    setSucursalSeleccionada(sucursal);
    setDireccion(sucursal.sucDireccion);
    sessionStorage.setItem('sucursalSeleccionada', JSON.stringify(sucursal));

    // 🔁 Obtener odont_rut desde el flujo en sessionStorage (si aplica)
    let odontRutAsignado = null;
    const tipo = sessionStorage.getItem('url_mpTipoTxt');
    const valor = sessionStorage.getItem('url_mpTipoVal');

    if (tipo === 'odontrut' && valor) {
      odontRutAsignado = parseInt(valor);
    }

    // ✅ Obtener lista de odontólogos disponibles en la sucursal
    let odontologosEspecialidad = [];
    if (sucursal.odontologos && sucursal.odontologos.length > 0) {
      odontologosEspecialidad = sucursal.odontologos.map(o => o.odontRut);
    }

    setContextData((prev) => ({
      ...prev,
      sucursalId: sucursal.sucId,
      sucursalNombre: sucursal.sucNombre,
      sucursalDireccion: sucursal.sucDireccion,
      odontologoRut: odontRutAsignado, // Rut único (flujo SeleccionaProfSuc)
      odontRuts: odontologosEspecialidad, // Lista completa de odontólogos (flujo SeleccionaEspSuc)
      paginaOrigen: 'SeleccionaProfSuc',
      selectedDate: prev.selectedDate || new Date().toISOString().split("T")[0],
    }));

    logEvento({
      paso: 'SeleccionaTipoHora',
      evento: 'seleccion_sucursal',
      descripcion: `Usuario seleccionó la sucursal ${sucursal.sucNombre}`,
      campo: 'sucursalId',
      valor: sucursal.sucId
    });

    registrarEventoVisual({
      paso: 'SeleccionaTipoHora',
      evento: 'seleccion_sucursal',
      descripcion: `Sucursal seleccionada: ${sucursal.sucNombre}`
    });
  };
  
  const handleNextClick = () => {
    if (sucursalSeleccionada) {
      logEvento({
        paso: 'SeleccionaTipoHora',
        evento: 'click_siguiente',
        descripcion: 'Usuario presionó Siguiente en SeleccionaTipoHora'
      });

      navigate('/SeleccionaFecHora');
    }
  };

  const openGoogleMaps = () => {
    if (sucursalSeleccionada) {
      const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(direccion)}`;
      logEvento({
        paso: 'SeleccionaTipoHora',
        evento: 'click_direccion_google_maps',
        descripcion: `Usuario abrió dirección de sucursal ${sucursalSeleccionada?.sucNombre} en Google Maps`
      });
      window.open(mapsUrl, '_blank');
    }
  };

  return (
    <PageContainer style={{ display: "flex", flexDirection: "column", height: "100vh" }} showFooterButtons={false}>
    <WizardPaso2 />
    <Content>
      <Title>Hola <span style={{ fontWeight: 'bold', color: '#00547F' }}>{nombrePaciente ? `${nombrePaciente},` : ','}</span> selecciona tu sucursal</Title>
      <Subtitle>Elige la sucursal donde deseas agendar tu cita</Subtitle>
      <SucursalContainer>
        <SucursalGrid>
          {sucursales.map((sucursal) => (
            <SucursalCard
              key={sucursal.sucId}
              isSelected={sucursalSeleccionada?.sucId === sucursal.sucId}
              onClick={() => handleSucursalChange(sucursal)}
            >
              <span>{sucursal.sucNombre}</span>
            </SucursalCard>
          ))}
        </SucursalGrid>
        <DireccionBox onClick={openGoogleMaps}>
          <strong>Dirección:</strong> {direccion}
          {sucursalSeleccionada && (
            <LocationContainer>
              <LocationIcon />
              <span>(Click para abrir en Google Maps)</span>
            </LocationContainer>
          )}
        </DireccionBox>
      </SucursalContainer>

      {/* 🔵 Agregado nuevo bloque de botones personalizados */}
      <ButtonContainer>
        <VolverButton onClick={() => navigate('/IndexPac')}>
          Volver
        </VolverButton>
        <SiguienteButton onClick={handleNextClick} disabled={!sucursalSeleccionada}>
          Siguiente
        </SiguienteButton>
      </ButtonContainer>
    </Content>
    </PageContainer>
  );
};

const SucursalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin: auto;
  margin-top: 20px;
  flex-grow: 1;
`;

const SucursalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 25px; /* Ajustable, puedes modificarlo luego */
  width: 100%;
  max-width: 700px;
  overflow-y: auto;
  padding-top: 20px;
  padding-bottom: 10px; /* Se redujo para permitir que DireccionBox suba */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    max-height: 300px;
  }
`;

const SucursalCard = styled.div`
  background: ${(props) => (props.isSelected ? '#00BCD4' : '#f5f5f5')};
  padding: 18px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: ${(props) => (props.isSelected ? '#ffffff' : '#336699')}; /* Azul más suave en vez de negro */
  box-shadow: ${(props) => (props.isSelected ? '0px 4px 10px rgba(0, 188, 212, 0.6)' : '2px 2px 5px rgba(0, 0, 0, 0.1)')};

  &:hover {
    background: #00acc1;
    transform: scale(1.08);
    color: #ffffff;
  }
`;

const DireccionBox = styled.div`
  background: #d1ecf1; /* Color de fondo similar a alert-info de Bootstrap */
  color: #0c5460; /* Color de texto Bootstrap */
  border: 1px solid #bee5eb; /* Borde del alert-info */
  padding: 14px;
  margin-top: 60px; /* Mantiene la posición */
  margin-bottom: 0px;
  border-radius: 8px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: normal;
  cursor: pointer;
  transition: opacity 0.3s ease;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Sombra sutil como Bootstrap */

  strong {
    font-weight: 600;
    color: #00547F;
  }

  &:hover {
    opacity: 0.85;
    background: #c4e3eb; /* Color más claro al hacer hover */
  }

  @media (max-width: 600px) {
    margin-top: 50px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 20px 0;
  background-color: white;
  width: 100%;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
`;

const LocationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; /* Centra horizontalmente */
  gap: 5px;
  margin-top: 5px;
  width: 100%; /* Asegura que ocupe el espacio completo */
`;

const LocationIcon = styled(FaMapMarkerAlt)`
  color: #00BEB8;
  font-size: 18px;
`;

const VolverButton = styled.button`
  background-color: #fff;
  color: #6c757d;
  border: 1px solid #6c757d;
  border-radius: 20px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
  }
`;

const SiguienteButton = styled.button`
  background-color: #00cfd4;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #00bfc4;
  }

  &:disabled {
    background-color: #e9ecef;
    color: #adb5bd;
    cursor: not-allowed;
  }
`;

export default SeleccionaTipoHora;